(function () {
  'use strict';

  // Seeded LCG PRNG (seed 42) — deterministic grain on every render
  function makePrng(seed) {
    var s = seed >>> 0;
    return function () {
      s = (Math.imul(1664525, s) + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }

  function draw() {
    var canvas = document.getElementById('paper-canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var dw = window.innerWidth;
    var dh = Math.max(document.body.scrollHeight, window.innerHeight);
    var dpr = window.devicePixelRatio || 1;
    canvas.width = dw * dpr;
    canvas.height = dh * dpr;
    canvas.style.width = dw + 'px';
    canvas.style.height = dh + 'px';
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, dw, dh);

    var rng = makePrng(42);
    function rand(a, b) { return rng() * (b - a) + a; }

    // Grid lines — 28px, 18% opacity (matches Flutter GridPainter)
    ctx.strokeStyle = 'rgba(58,74,30,0.18)';
    ctx.lineWidth = 0.8;
    for (var x = 0; x <= dw; x += 28) {
      ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, dh); ctx.stroke();
    }
    for (var y = 0; y <= dh; y += 28) {
      ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(dw, y); ctx.stroke();
    }

    // Grain — 6000 near-horizontal short strokes (matches Flutter TexturePainter grain)
    ctx.lineCap = 'round';
    for (var i = 0; i < 6000; i++) {
      var gx = rand(0, dw);
      var gy = rand(0, dh);
      var gl = rand(0.5, 4.5);
      var ga = rand(-0.2, 0.2); // near-horizontal, ±0.2 rad
      var go = rand(0.06, 0.24);
      ctx.strokeStyle = 'rgba(106,90,58,' + go.toFixed(2) + ')';
      ctx.lineWidth = rand(0.2, 0.8);
      ctx.beginPath();
      ctx.moveTo(gx, gy);
      ctx.lineTo(gx + Math.cos(ga) * gl, gy + Math.sin(ga) * gl);
      ctx.stroke();
    }

    // Horizontal scratches — 60 strokes (Flutter TexturePainter)
    for (var j = 0; j < 60; j++) {
      var sx = rand(0, dw * 0.4);
      var sy = rand(0, dh);
      var sl = rand(dw * 0.5, dw);
      var so = rand(0.04, 0.14);
      ctx.strokeStyle = 'rgba(106,90,58,' + so.toFixed(2) + ')';
      ctx.lineWidth = 0.4;
      ctx.beginPath();
      ctx.moveTo(sx, sy);
      ctx.lineTo(sx + sl, sy);
      ctx.stroke();
    }

    // Long subtle scratches — 8 strokes
    for (var k = 0; k < 8; k++) {
      var lx = rand(0, dw);
      var ly = rand(0, dh);
      var ll = rand(40, 160);
      var la = rand(-0.075, 0.075);
      ctx.strokeStyle = 'rgba(106,90,58,0.07)';
      ctx.lineWidth = 1.0;
      ctx.beginPath();
      ctx.moveTo(lx, ly);
      ctx.lineTo(lx + Math.cos(la) * ll, ly + Math.sin(la) * ll);
      ctx.stroke();
    }

    // Left margin rule (pink-tan, x=52) — Flutter MarginPainter
    ctx.strokeStyle = 'rgba(232,180,184,0.5)';
    ctx.lineWidth = 1.0;
    ctx.beginPath(); ctx.moveTo(52, 0); ctx.lineTo(52, dh); ctx.stroke();

    // Vignette — 4 points: TL, TR, BR corners + centre darken
    function cornerVig(cx, cy, r, color) {
      var g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
      g.addColorStop(0, color);
      g.addColorStop(1, 'rgba(204,153,68,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, dw, dh);
    }
    var cr = Math.max(dw, dh) * 0.8;
    cornerVig(0, 0, cr, 'rgba(204,153,68,0.09)');          // TL
    cornerVig(dw, 0, cr, 'rgba(204,153,68,0.09)');         // TR
    cornerVig(dw, dh, cr, 'rgba(204,153,68,0.09)');        // BR

    // Centre darken vignette (edges darker than centre)
    var vcx = dw / 2, vcy = dh / 2;
    var vr = Math.max(dw, dh) * 0.82;
    var vg = ctx.createRadialGradient(vcx, vcy, vr * 0.25, vcx, vcy, vr);
    vg.addColorStop(0, 'rgba(90,74,42,0)');
    vg.addColorStop(1, 'rgba(90,74,42,0.22)');
    ctx.fillStyle = vg;
    ctx.fillRect(0, 0, dw, dh);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(draw, 180);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draw);
  } else {
    draw();
  }

  window.addEventListener('resize', onResize);
})();
